export const NOTE_REF_NAME = {
    NOTE_CANVAS: 'noteCanvasRef',
    NOTE_CONTAINER: 'noteContainerRef',
    NOTE_TOP: 'noteTopDivRef',
    NOTE_BOTTOM: 'noteBottomDivRef',
};
